<template>
  <div class="web-mask" @click="close">
    <div class="web">
      <div class="web-head">
        {{ this.$store.state.drug.selectedDrug.generic_name }}
        <div class="close-button"  @click="close">&times;</div>
      </div>
      <iframe :src="iframeSrc" frameborder="0" v-if="prefixSet"></iframe>
      <div class="with-child-centered" style="width: 1000px; height: 600px" v-else>未設定外部網址</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DrugInfoWeb',
  computed: {
    iframeSrc() {
      const prefix = this.$store.state.generalSetting.weburl_prefix;
      const drugId = this.$store.state.drug.selectedDrug.code;
      return `${prefix}${drugId}`;
    },
    prefixSet() {
      const prefix = this.$store.state.generalSetting.weburl_prefix;
      if (prefix === '' || prefix === null || prefix === undefined) return false;
      return true;
    },
  },
  methods: {
    close() {
      this.$emit('closetab');
    },
  },
};
</script>

<style lang="sass">
.web-mask
  position: fixed
  top: 0
  left: 0
  height: 100vh
  width: 100vw
  background: rgba(0,0,0,0.3)
  z-index: 10
  display: flex
  justify-content: center
  align-items: center
  .web
    background: white
    iframe
      width: 1000px
      height: 600px
    .web-head
      width: 100%
      background: rgba(0,0,0,0.6)
      height: 30px
      color: white
      text-align: center
      line-height: 30px
      position: relative

    .close-button
      position: absolute
      top: 0
      right: 0
      background: red
      width: 30px
      height: 30px
      color: white
      display: flex
      justify-content: center
      align-items: center
      cursor: pointer
</style>





// WEBPACK FOOTER //
// DrugInfoWeb.vue?131a6b33